import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { WarehouseTransfer } from '../models/entities/warehouse-transfer';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { WarehouseTransferRequestDto } from '../models/dtos/warehouse-transfer-request-dto';
import { WarehouseInventory } from '../models/entities/warehouse-inventory';
import { WarehouseInventoryRequest } from '../models/dtos/warehouse-inventory-request';


@Injectable({
    providedIn: 'root'
})
export class WarehouseService {


    constructor(
        private networkService  : LeanNetworkService,
        public userService      : UserService) {
    }

    
    //------------------------------------------------------------------------------------
    // sordersProcessing
    //------------------------------------------------------------------------------------
    sordersProcessing(date : Date) : Promise<boolean>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/sordersProcessing', request).then(result => {
                return resolve(true);
            }, error => {
                reject(error);
            });
        });
    }



    //------------------------------------------------------------------------------------
    // WarehouseTransfers Get
    //------------------------------------------------------------------------------------
    warehouseTransfersGet(warehouseTransferCode : string, roleCode : string, progressLevel :number, 
        startDate             : Date, 
        endDate               : Date, 
        tt_regular            : boolean,
        tt_presales           : boolean,
        tt_regular_mobile     : boolean,
        tt_purchase           : boolean,
        tt_direct             : boolean,
        tt_sr_to_sr           : boolean,
        tt_handover           : boolean,
        includeCanceled       : boolean) : Promise<WarehouseTransfer[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code    = warehouseTransferCode;
        request.strArg1 = roleCode;
        request.lngArg1 = progressLevel;
        request.dteArg1 = startDate;
        request.dteArg2 = endDate;
        request.blnArg1 = includeCanceled;
        request.booleans = [tt_regular, tt_presales, tt_regular_mobile,  tt_purchase, tt_direct, tt_sr_to_sr, tt_handover];     

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransfersGet', request).then(result => {
                return resolve(result.warehouseTransfers);
            }, error => {
                reject(error);
            });
        });
    }

      
        warehouseTransfersForShipmentGet(toShip: boolean, toReceive: boolean) : Promise<WarehouseTransfer[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        let progressLevel       = 50;
        let tt_regular          = false;
        let tt_presales         = false;
        let tt_regular_mobile   = false;
        let tt_purchase         = true;
         let tt_direct          = false;
         let tt_sr_to_sr        = false;
         let tt_handover        = false;

        request.lngArg1 = progressLevel;
        request.booleans = [tt_regular, tt_presales, tt_regular_mobile,  tt_purchase, tt_direct, tt_sr_to_sr, tt_handover];     

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransfersGet', request).then(result => {
                return resolve(result.warehouseTransfers);
            }, error => {
                reject(error);
            });
        });
    }


    //------------------------------------------------------------------------------------
    // WarehouseTransfer Get
    //------------------------------------------------------------------------------------
    warehouseTransferGet(warehouseTransferCode : string, withSdeliveries? : boolean, withWarehouseTransferLine? : boolean) : Promise<WarehouseTransfer>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code    = warehouseTransferCode;
        request.blnArg1 = withSdeliveries;
        request.blnArg2 = withWarehouseTransferLine;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferGet', request).then(result => {
                return resolve(result.warehouseTransfer);
            });
        });
    }


    
    //------------------------------------------------------------------------------------
    // warehouseTransfer Cancel
    //------------------------------------------------------------------------------------
    warehouseTransferCancel(warehouseTransferCode : string) : Promise<WarehouseTransfer>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code    = warehouseTransferCode;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferCancel', request).then(result => {
                return resolve(result.warehouseTransfer);
            });
        });
    }
    //------------------------------------------------------------------------------------
    // Warehouse Transfer Sdelivery Notes Update
    //------------------------------------------------------------------------------------
    warehouseTransferSdeliveryNotesUpdate(warehouseTransfer : WarehouseTransfer) : Promise<WarehouseTransfer>{
        let request: WarehouseTransferRequestDto = new WarehouseTransferRequestDto(this.userService.userInfo);
        request.warehouseTransfer = warehouseTransfer;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferSdeliveryNotesUpdate', request).then(result => {
                return resolve(result.warehouseTransfer);
            }, error => {
                reject(error);
            });
        });
    }

    //------------------------------------------------------------------------------------
    // WarehouseTransfer Save
    //------------------------------------------------------------------------------------
    warehouseTransferSave(warehouseTransfer : WarehouseTransfer) : Promise<WarehouseTransfer>{
        let request: WarehouseTransferRequestDto = new WarehouseTransferRequestDto(this.userService.userInfo);
        request.warehouseTransfer = warehouseTransfer;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferSave', request).then(result => {
                return resolve(result.warehouseTransfer);
            }, error => {
                reject(error);
            });
        });
    }

    //------------------------------------------------------------------------------------
    // WarehouseTransfer Assign
    //------------------------------------------------------------------------------------
    warehouseTransferAssign(warehouseTransfer : WarehouseTransfer) : Promise<WarehouseTransfer>{
        let request: WarehouseTransferRequestDto = new WarehouseTransferRequestDto(this.userService.userInfo);
        request.warehouseTransfer = warehouseTransfer;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferAssign', request).then(result => {
                return resolve(result.warehouseTransfer);
            }, error => {
                reject(error);
            });
        });
    }



    //------------------------------------------------------------------------------------
    // WarehouseTransfer Release
    //------------------------------------------------------------------------------------
    warehouseTransferRelease(warehouseTransferCode : string) : Promise<WarehouseTransfer>{
        let request : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code = warehouseTransferCode;
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseTransferRelease', request).then(result => {
                return resolve(result.warehouseTransfer);
            }, error => {
                reject(error);
            });
        });
    }
    

    //------------------------------------------------------------------------------------
    // Warehouse Inventory List
    //------------------------------------------------------------------------------------
    warehouseInventorysGet(startDate : Date, endDate : Date) : Promise<WarehouseInventory[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.dteArg1 = startDate;
        request.dteArg2 = endDate;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseInventorysGet', request).then(result => {
                return resolve(result.warehouseInventorys);
            }, error => {
                reject(error);
            });
        });
    }


    //------------------------------------------------------------------------------------
    // Warehouse Inventory Get
    //------------------------------------------------------------------------------------
    warehouseInventoryGet(warehouseInventoryCode : string) : Promise<WarehouseInventory>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = warehouseInventoryCode;
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseInventoryGet', request).then(result => {
                return resolve(result.warehouseInventory);
            }, error => {
                reject(error);
            });
        });
    }

    //------------------------------------------------------------------------------------
    // Warehouse Inventory Initiate
    //------------------------------------------------------------------------------------
    warehouseInventoryInitiate() : Promise<WarehouseInventory>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseInventoryInitiate', request).then(result => {
                return resolve(result.warehouseInventory);
            }, error => {
                reject(error);
            });
        });
    }

    
    //------------------------------------------------------------------------------------
    // Warehouse Inventory Save
    //------------------------------------------------------------------------------------
    warehouseInventorySave(warehouseInventory : WarehouseInventory) : Promise<WarehouseInventory>{
        let request: WarehouseInventoryRequest = new WarehouseInventoryRequest(this.userService.userInfo);
        request.warehouseInventory = warehouseInventory;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseInventorySave', request).then(result => {
                return resolve(result.warehouseInventory);
            }, error => {
                reject(error);
            });
        });
    }
    
    
    //------------------------------------------------------------------------------------
    // Warehouse Inventory Close
    //------------------------------------------------------------------------------------
    warehouseInventoryClose(warehouseInventoryCode : string) : Promise<WarehouseInventory>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = warehouseInventoryCode;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/warehouse/warehouseInventoryClose', request).then(result => {
                return resolve(result.warehouseInventory);
            }, error => {
                reject(error);
            });
        });
    }

}



/*
    //------------------------------------------------------------------------------------
    // Warehouses Managed Get
    //------------------------------------------------------------------------------------
    warehousesManaged : BasicItem[] = null;
    currentLogin       : string;
    warehousesManagedGet() : Promise<BasicItem[]>{

        return new Promise((resolve, reject) => {
            if ((this.warehousesManaged != null) && (this.currentLogin == this.userService.userInfo.login)) {
                return resolve(this.warehousesManaged); 
            } else {
                let request: BaseRequest = new BaseRequest(this.userService.userInfo);
                this.networkService.post('sales/warehouse/warehousesManagedGet', request).then(result => {
                    this.warehousesManaged = result.items;
                    this.currentLogin = this.userService.userInfo.login;
                    return resolve(this.warehousesManaged);
                }, error => {
                    reject(error);
                });
            }
        });
    }
    */

